<template>
    <div class="col-12 mx-auto">
        <div class="card">

            <div class="card-header" v-if="showNewButton || showSettingsBtn || showCertificatesBtn">
                <button v-if="showCertificatesBtn"
                    class="btn btn-success"
                    @click.stop="newCertificatesBtnClick">
                    <i class="fas fa-plus"></i>
                    {{ $t('buttons.newCertificates.tooltipText') }}
                </button>
                <button type="button" class="btn btn-primary btn-lg"
                        v-if="showNewButton && hasParticipantEditRights"
                        @click="createBtnClick">
                    {{ $t('buttons.create.btnText') }}
                </button>
                <i class="fas fa-cogs pointer fa-2x float-right text-primary"
                   v-if="showSettingsBtn"
                   @click.stop="changeGridSettings"
                   data-toggle="tooltip"
                   :title="settingsTooltipText"></i>

                <grid-user-settings ref="userSettings"
                                    :schemaModelFields="schemaModelFields"
                                    :componentName="componentName"
                                    :useLabelAsTitle="true"
                                    :showUserSettings="true"
                                    :gridOptions="userSettings"
                                    v-if="showUserSettingsForm"
                                    @saveGridSettings="saveGridSettings"
                                    @loadGridSettings="loadGridSettings"
                                    @userSettingsChanged="userSettingsChanged"
                                    @deleteGridSettings="deleteGridSettings">
                </grid-user-settings>
            </div>

            <div class="card-body" id="grid">
                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :filter="filter"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'count'"
                                  :schema-data="'items'"
                                  :page-size='gridOptions.pageable.size'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd">
                </kendo-datasource>

                <kendo-grid ref="lecturersListGrid"
                            :data-source-ref="'datasource1'"
                            :pageable="gridOptions.pageable"
                            :navigatable="gridOptions.navigatable"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :toolbar="gridOptions.toolbar"
                            :excel="gridOptions.excel"
                            :data-bound="dataBound">
                    <kendo-grid-column :selectable="true" :width="60" :lockable="true" :hidden="!showBtns"
                                       :locked="true"></kendo-grid-column>
                    <!--<kendo-grid-column :field="'id'"
                       :filterable="false"
                       :title="$t('registers.events.participants.gridHeaders.id')"
                       :width="100"
                       :hidden="true"
                       :lockable="true"
                       :locked="false">
    </kendo-grid-column>-->
                    <kendo-grid-column :field="'participationType'"
                                       :title="$t('registers.events.participants.gridHeaders.participationType')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <!--<kendo-grid-column :field="'participationTypeEn'"
                       :title="$t('registers.events.participants.gridHeaders.participationType')"
                       :width="200"
                       :lockable="true"
                       :locked="false"
                       :hidden="!isEnVersion">
    </kendo-grid-column>-->
                    <kendo-grid-column v-if="showBtns && hasParticipantEditRights"
                                       :template="btnsTemplate"
                                       field="btnsColumn"
                                       :title="$t('registers.events.participants.gridHeaders.management')"
                                       :sortable="false"
                                       :filterable="false"
                                       :width="100"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'syncWithMoodle'"
                                       :title="$t('registers.events.participants.gridHeaders.syncWithMoodle')"
                                       :width="100"
                                       :template="syncedCellTemplate"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <!-- <kendo-grid-column :field="'notified'"
                                   :title="$t('registers.events.participants.gridHeaders.notified')"
                                   :width="100"
                                   :template="notifiedCellTemplate"
                                   :sortable="true"
                                   :filterable="true"
                                   :lockable="true"
                                   :locked="false">
                    </kendo-grid-column> -->
                    <kendo-grid-column field="hasCertificate"
                                   :title="$t('registers.events.participants.gridHeaders.hasCertificate')"
                                   :width="150"
                                   :template="hasCertificateCellTemplate"
                                   :sortable="false"
                                   :filterable="false"
                                   :lockable="true"
                                   :locked="false"
                    />
                    <kendo-grid-column :field="'titleDegree'"
                                       :title="$t('registers.events.participants.gridHeaders.titleDegree')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'titleDegreeEn'"
                                       :title="$t('registers.events.participants.gridHeaders.titleDegree')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'fullName'"
                                       :title="$t('registers.events.participants.gridHeaders.name')"
                                       :width="300"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'fullNameTransliterated'"
                                       :title="$t('registers.events.participants.gridHeaders.nameTransliterated')"
                                       :width="300"
                                       :sortable="false"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'identificationType'"
                                       :title="$t('registers.events.participants.gridHeaders.identificationType')"
                                       :width="100"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'identificationNumber'"
                                       :title="$t('registers.events.participants.gridHeaders.identificationNumber')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'email'"
                                       :title="$t('registers.events.participants.gridHeaders.email')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'position'"
                                       :title="$t('registers.events.participants.gridHeaders.position')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'positionEn'"
                                       :title="$t('registers.events.participants.gridHeaders.position')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'positionStatistic'"
                                       :title="$t('registers.events.participants.gridHeaders.positionStatistic')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'positionStatisticEn'"
                                       :title="$t('registers.events.participants.gridHeaders.positionStatistic')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'positionStr'"
                                       :title="$t('registers.events.participants.gridHeaders.positionFullName')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'educationDegree'"
                                       :title="$t('registers.events.participants.gridHeaders.educationDegree')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'educationDegreeEn'"
                                       :title="$t('registers.events.participants.gridHeaders.educationDegree')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <!--<kendo-grid-column :field="'institutionNomenclature'"
                       :title="$t('registers.events.participants.gridHeaders.institutionNomenclature')"
                       :width="250"
                       :lockable="true"
                       :locked="false"
                       :hidden="isEnVersion">
    </kendo-grid-column>
    <kendo-grid-column :field="'institutionNomenclatureEn'"
                       :title="$t('registers.events.participants.gridHeaders.institutionNomenclature')"
                       :width="250"
                       :lockable="true"
                       :locked="false"
                       :hidden="!isEnVersion">
    </kendo-grid-column>-->
                    <kendo-grid-column :field="'institutionRegister'"
                                       :title="$t('registers.events.participants.gridHeaders.institutionNomenclature')"
                                       :width="250"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'institutionRegisterLocation'"
                                       :title="$t('registers.events.participants.gridHeaders.institutionCity')"
                                       :width="250"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'phone'"
                                       :title="$t('person.phone')"
                                       :width="250"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'mobilePhone'"
                                       :title="$t('person.mobilePhone')"
                                       :width="250"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'createdAt'"
                                       :title="$t('registers.events.participants.gridHeaders.createdAt')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :format="'{0: dd-MM-yyyy HH:mm:ss}'"
                                       :hidden="!hasParticipantEditRights">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'updatedAt'"
                                       :title="$t('registers.events.participants.gridHeaders.updatedAt')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :format="'{0: dd-MM-yyyy HH:mm:ss}'"
                                       :hidden="!hasParticipantEditRights">
                    </kendo-grid-column>
                    <!-- <kendo-grid-column :field="'notificationDate'"
                                       :title="$t('registers.events.participants.gridHeaders.notificationDate')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :format="'{0: dd-MM-yyyy HH:mm:ss}'"
                                       :hidden="!hasParticipantEditRights">
                    </kendo-grid-column> -->
                </kendo-grid>
            </div>
        </div>

        <PersonEditModal v-model="personModel" :show="showPersonEdit" showEnNames
            @onClose="onPersonEditClose"
            @onSave="onPersonEdit"></PersonEditModal>
        <PersonDetailsModal v-model="personModel" :show="showPersonDetails" :allowEdit="false"
                            @onClose="onPersonDetailsClose"></PersonDetailsModal>
        <ParticipantEditModal v-model="participantModel" :show="showParticipanrEdit" @onClose="onParticipantEditClose"
                              @onSave="onParticipantEdit"></ParticipantEditModal>
        <ParticipantsEditModal v-model="participantsUpdateModel" :show="showParticipantsEdit"
                               @onClose="onParticipantsEditClose" @onSave="onParticipantEdit"></ParticipantsEditModal>
    </div>

</template>
<script src="https://kendo.cdn.telerik.com/2019.2.619/js/pako_deflate.min.js"></script>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip'
    import GridUserSettings from "../../components/grid/UserSettings";
    import BtnsTemplate from "../../components/grid/StandardBtnsTemplate";
    import PersonEditModal from '../../components/person/edit.modal';
    import PersonDetailsModal from '../../components/person/details.modal';
    import personService from '../../services/person.service';
    import eventService from '@/services/event.service';
    import participantService from '../../services/participant.service';
    import ParticipantEditModal from '../../components/participants/edit.modal';
    import personalizationService from '@/services/personalization.service';
    import { mapGetters } from 'vuex';
    import ParticipantsEditModal from "../../components/participants/multipleEdit.modal";
    import { ParticipantsUpdateModel } from '../../models/models';

    /*
    Renders the grid in "DejaVu Sans" font family, which is
    declared in kendo.common.css. It also declares the paths to the
    fonts below using <tt>kendo.pdf.defineFont</tt>, because the
    stylesheet is hosted on a different domain.
    */
    kendo.pdf.defineFont({
        "DejaVu Sans": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans.ttf",
        "DejaVu Sans|Bold": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Bold.ttf",
        "DejaVu Sans|Bold|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "DejaVu Sans|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "WebComponentsIcons": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/glyphs/WebComponentsIcons.ttf"
    });

    export default {
        name: 'lecturers-grid',
        components: {
            'grid-user-settings': GridUserSettings,
            PersonEditModal,
            PersonDetailsModal,
            ParticipantEditModal,
            ParticipantsEditModal
        },
        props: {
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: true,
                type: Boolean
            },
            showNewButton: {
                default: true,
                type: Boolean
            },
            showResizeIcon: {
                default: true,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            relatedEventId: {
                default: 0,
                type: Number
            },
            showCertificatesBtn: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                componentName: "LecturersListGrid",
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                customSettingsLoaded: false,
                titleKey: 'registers.forms.title',
                eventDetails: null,
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: false, visible: true },
                    registerEntityId: {
                        name: 'registerEntityId',
                        type: 'number',
                        editable: false,
                        nullable: false,
                        visible: true
                    },
                    registerFieldId: {
                        name: 'registerFieldId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    personId: { name: 'personId', type: 'number', editable: false, nullable: false, visible: true },
                    relationTypeId: {
                        name: 'relationTypeId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    participationType: {
                        name: 'participationType',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    participationTypeEn: {
                        name: 'participationTypeEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    relationTypeName: {
                        name: 'relationTypeName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    relationTypeNameEn: {
                        name: 'relationTypeNameEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    isRelationTypeForParticipation: {
                        name: 'isRelationTypeForParticipation',
                        type: 'boolean',
                        editable: false,
                        nullable: false,
                        visible: true
                    },
                    relationTypeCode: {
                        name: 'relationTypeCode',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    eventPersonTypeId: {
                        name: 'eventPersonTypeId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    registerEntityParticipantMigrationId: {
                        name: 'registerEntityParticipantMigrationId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    createdBy: { name: 'createdBy', type: 'string', editable: false, nullable: true, visible: true },
                    createdAt: { name: 'createdAt', type: 'date', editable: false, nullable: true, visible: true },
                    updatedBy: { name: 'updatedBy', type: 'string', editable: false, nullable: true, visible: true },
                    updatedAt: { name: 'updatedAt', type: 'date', editable: false, nullable: true, visible: true },
                    migrationData: { name: 'migrationDataS', type: 'string', editable: false, nullable: true, visible: true },
                    rejected: { name: 'rejected', type: 'boolean', editable: false, nullable: false, visible: true },
                    deleted: { name: 'deleted', type: 'boolean', editable: false, nullable: false, visible: true },
                    firstName: { name: 'firstName', type: 'string', editable: false, nullable: true, visible: true },
                    middleName: { name: 'middleName', type: 'string', editable: false, nullable: true, visible: true },
                    lastName: { name: 'lastName', type: 'string', editable: false, nullable: true, visible: true },
                    fullName: { name: 'fullName', type: 'string', editable: false, nullable: true, visible: true },
                    fullNameTransliterated: {
                        name: 'fullNameTransliterated',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    identificationType: {
                        name: 'identificationType',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    identificationNumber: {
                        name: 'identificationNumber',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    phone: { name: 'phone', type: 'string', editable: false, nullable: true, visible: true },
                    mobilePhone: { name: 'mobilePhone', type: 'string', editable: false, nullable: true, visible: true },
                    email: { name: 'email', type: 'string', editable: false, nullable: true, visible: true },
                    position: { name: 'position', type: 'string', editable: false, nullable: true, visible: true },
                    positionEn: { name: 'positionEn', type: 'string', editable: false, nullable: true, visible: true },
                    description: { name: 'description', type: 'string', editable: false, nullable: true, visible: true },
                    gender: { name: 'gender', type: 'string', editable: false, nullable: true, visible: true },
                    genderEn: { name: 'genderEn', type: 'string', editable: false, nullable: true, visible: true },
                    hasParent: { name: 'hasParent', type: 'boolean', editable: false, nullable: true, visible: true },
                    parentFirstName: {
                        name: 'parentFirstName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    parentMiddleName: {
                        name: 'parentMiddleName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    parentLastName: {
                        name: 'parentLastName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    parentFullName: {
                        name: 'parentFullName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    username: { name: 'username', type: 'string', editable: false, nullable: true, visible: true },
                    participantMigrationId: {
                        name: 'participantMigrationId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    lecturerMigrationId: {
                        name: 'lecturerMigrationId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    organizerMigrationId: {
                        name: 'organizerMigrationId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    educationDegree: {
                        name: 'educationDegree',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    educationDegreeEn: {
                        name: 'educationDegreeEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    titleDegree: { name: 'titleDegree', type: 'string', editable: false, nullable: true, visible: true },
                    titleDegreeEn: { name: 'titleDegreeEn', type: 'string', editable: false, nullable: true, visible: true },
                    institutionNomenclature: {
                        name: 'institutionNomenclature',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    institutionNomenclatureEn: {
                        name: 'institutionNomenclatureEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    institutionRegister: {
                        name: 'institutionRegister',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    institutionRegisterLocation: {
                        name: 'institutionRegisterLocation',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    hasChanges: { name: 'hasChanges', type: 'boolean', editable: false, nullable: true, visible: true },
                    syncWithMoodle: {
                        name: 'syncWithMoodle',
                        type: 'boolean',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    syncMoodleResult: {
                        name: 'syncMoodleResult',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    positionStatistic: { name: 'positionStatistic', type: 'string', editable: false, nullable: true, visible: true },
                    positionStatisticEn: { name: 'positionStatisticEn', type: 'string', editable: false, nullable: true, visible: true },
                    positionStr: { name: 'positionStr', type: 'string', editable: false, nullable: true, visible: true },
                    notified: {
                        name: "notified",
                        type: "boolean",
                        editable: false,
                        nullable: true,
                        visible: true,
                    },
                    notificationDate: {
                        name: "notificationDate",
                        type: "date",
                        editable: false,
                        nullable: true,
                        visible: true,
                    },
                    directorNorified: {
                        name: "directorNorified",
                        type: "boolean",
                        editable: false,
                        nullable: true,
                        visible: true,
                    },
                    directorNotificationDate: {
                        name: "directorNotificationDate",
                        type: "date",
                        editable: false,
                        nullable: true,
                        visible: true,
                    },
                },
                formToEventFields: {
                    id: { name: 'id', from: 'id', type: 'number', nullable: false },
                    name: { name: 'name', from: 'name', type: 'string', nullable: false },
                    nameEn: { name: 'name', from: 'name', type: 'string', nullable: true },
                    type: { name: 'name', from: 'name', type: 'string', nullable: true },
                    typeEn: { name: 'name', from: 'name', type: 'string', nullable: true }
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/lectors/' + (this.relatedEventId ? 'lecturersForEvent' : 'listAllLecturers'),
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    toolbar: this.showBtns
                    ? [
                            {
                                name: 'EditSelectedLecturers',
                                template: this.toolbarEditSelectedTemplate,
                            },
                            {
                                name: 'NotifySelectedLecturers',
                                template: this.toolbarNotifySelectedTemplate,
                            },
                            {
                                name: 'excel',
                                text: this.$t("buttons.excelExport.tooltipText"),
                            },
                        ]
                    : [
                            {
                            name: 'excel',
                            text: this.$t("buttons.excelExport.tooltipText"),
                        },
                    ],
                    excel: {
                        fileName: 'Lecturers.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true,
                    },
                },
                working: false,
                showUserSettingsForm: false,
                showPersonEdit: false,
                personModel: null,
                showPersonDetails: false,
                participantModel: null,
                showParticipanrEdit: false,
                showParticipantsEdit: false,
                participantsUpdateModel: null,
            }
        },
        methods: {
            toolbarEditSelectedTemplate() {
                return `<a role='button' id='editSelectedLecturersBtn' class='k-button k-button-icontext'>
                        <span class='k-icon k-i-pencil'></span>${this.$t('buttons.editSelected.btnText')}</a>`;
            },
            toolbarNotifySelectedTemplate() {
                return `<a role='button' id='notifySelectedLecturersBtn' class='k-button k-button-icontext'>
                        <span class='k-icon k-i-envelop'></span>${this.$t('buttons.notifySelected.btnText')}</a>`;
            },
            updateSelected(grid) {
                const selectedIds = this.$helpers.getGridSelectedRowsIds(grid);
                if (!selectedIds || selectedIds.length <= 0) {
                    this.participantsUpdateModel = null;

                    this.$vs.notify({
                        title: this.$t("buttons.edit.btnText"),
                        text: this.$t("registers.lecturers.emptySelection"),
                        color: "warning",
                        time: this.$store.getters.notificationDuration,
                    });

                    return;
                } else {
                    const selectedRowsPersonsNames = this.$helpers.getGridSelectedRowsByProperty(grid, "fullName");
                    const selectedRegisterEntityIds = this.$helpers.getGridSelectedRowsByProperty(grid, "registerEntityId");
                    const selectedRegisterEntityId = selectedRegisterEntityIds.filter((item, index, selectedRegisterEntityIds) => selectedRegisterEntityIds.indexOf(item) == index)[0];
                    this.participantsUpdateModel =
                    {
                        registerEntityToPersonIds: selectedIds,
                        participantNames: selectedRowsPersonsNames,
                        registerEntityId: selectedRegisterEntityId,
                        modalTitle: this.$t('registers.lecturers.multipleEditTitle')
                    };
                }

                this.showParticipantsEdit = true;
            },
            notifySelected(grid) {
                const selectedIds = this.$helpers.getGridSelectedRowsIds(grid);
                if (!selectedIds || selectedIds.length <= 0) {
                    this.$vs.notify({
                        title: this.$t("buttons.notifySelected.action"),
                        text: this.$t("registers.lecturers.emptySelection"),
                        color: "warning",
                        time: this.$store.getters.notificationDuration,
                    });

                    return;
                }

                participantService
                    .notifySelected({ eventId: this.relatedEventId, participants: selectedIds })
                    .then(() => {
                        this.$vs.notify({
                            title: this.$t('buttons.notifySelected.action'),
                            text: this.$t('notifications.success'),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        });
                    })
                    .catch((error) => {
                        this.$vs.notify({
                            title: this.$t('buttons.notifySelected.action'),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration,
                        });
                    })
                    .finally(() => {
                        this.refresh();
                    });
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            dataBound(e) {
                if (this.showSettingsBtn) {
                    if (!this.customSettingsLoaded) {
                        this.loadGridSettings();
                        this.customSettingsLoaded = true;
                    }
                }
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    return kendo.stringify(options);
                }
            },
            getGridOptions() {
                const grid = this.$refs.lecturersListGrid.kendoWidget();
                if (grid) {
                    return grid.getOptions();
                }
            },
            saveGridSettings() {
                const gridSettings = this.getGridOptions();
                const grid = this.$refs.lecturersListGrid.kendoWidget();

                if (gridSettings && grid) {
                    if (!gridSettings.loadedUserSettings) {
                        gridSettings.loadedUserSettings = true;
                    }

                    this.$refs.userSettings.setGridSettings(gridSettings);

                    personalizationService
                        .saveGridSettings(this.componentName, gridSettings)
                        .then((response) => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                                text: this.$helpers.responseMessage(response),
                                color: 'success',
                                time: this.$store.getters.notificationDuration,
                            });
                        })
                        .catch((error) => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: this.$helpers.errorColor(error),
                                time: this.$store.getters.notificationDuration,
                            });
                        })
                        .finally(() => {
                            this.setListeners();
                        });

                }
            },
            loadGridSettings() {
                personalizationService
                    .loadGridSettings(this.componentName)
                    .then((response) => {
                        try {
                            const gridOptionsBeforeMerge = this.getGridOptions();
                            var options = personalizationService.mergePersonGridSettings(
                                gridOptionsBeforeMerge,
                                response.data.settings
                            );

                            let grid = this.$refs.lecturersListGrid.kendoWidget();
                            if (options && grid) {
                                let syncWithMoodleColumn = options.columns.find(
                                    (col) => col.field === "syncWithMoodle"
                                );
                                if (syncWithMoodleColumn) {
                                    syncWithMoodleColumn.template = this.syncedCellTemplate;
                                }

                                let hasNotifiedColumn = options.columns.find(
                                    (col) => col.field === "notifiedCellTemplate"
                                );
                                if (hasNotifiedColumn) {
                                    hasNotifiedColumn.template = this.notifiedCellTemplate;
                                }

                                let hasCertificateColumn = options.columns.find(
                                    (col) => col.field === "hasCertificate"
                                );
                                if (hasCertificateColumn) {
                                    hasCertificateColumn.template = this.hasCertificateCellTemplate;
                                }

                                options.toolbar = gridOptionsBeforeMerge.toolbar;
                                grid.setOptions(options);
                                this.setListeners();

                                if (options.pageable.size !== grid.dataSource.options.pageSize) {
                                    grid.dataSource.pageSize(options.pageable.size);
                                    grid.refresh();
                                }

                                const userSettingsEditor = this.$refs.userSettings;
                                if (userSettingsEditor) {
                                    userSettingsEditor.setGridSettings(
                                        grid.getOptions()
                                    );
                                }
                            }

                            this.customSettingsLoaded = true;
                        } catch (e) {
                            this.customSettingsLoaded = true;
                        }
                    })
                    .catch((error) => {
                        this.customSettingsLoaded = true;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration,
                        });
                    });
            },
            loadGridSettings() {
                return this.$http.get('/api/personalization/' + this.componentName + '/getGridSettings'
                ).then((response) => {

                    try {
                        let options = JSON.parse(response.data.settings); // ������������� ����������� �������� � ������, ��� ��� ������
                        if (!options || !options.hasOwnProperty("columns")) {
                            return;
                        }

                        let grid = this.$refs.lecturersListGrid.kendoWidget();
                        if (grid) {
                            grid.setOptions(options);

                            if (options.pageable.size != grid.dataSource.options.pageSize) {
                                grid.dataSource.pageSize(options.pageable.size);
                                grid.refresh();
                            }

                            this.$refs.userSettings.setGridSettings(grid.getOptions());
                        }


                    } catch (e) {

                    }
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            deleteGridSettings() {
                personalizationService
                    .delteGridSettings(this.componentName)
                    .then((response) => {
                        this.$router.go();
                    })
                    .catch((error) => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration,
                        });
                    });
            },
            userSettingsChanged(userSettings, pageSizeChanged) {
                let grid = this.$refs.lecturersListGrid.kendoWidget();
                if (grid) {
                    try {
                        grid.setOptions(userSettings);
                        if (pageSizeChanged === true) {
                            if (userSettings.pageable.size === KendoGridPageSize.All) {
                                grid.dataSource.pageSize(this.$refs["datasource1"].kendoDataSource.total());
                            } else {
                                grid.dataSource.pageSize(userSettings.pageable.size);
                            }
                            grid.refresh();
                        }
                    } catch (e) {
                    }
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            changeGridSettings() {
                this.showUserSettingsForm = !this.showUserSettingsForm;
            },
            resize(componentName, size) {
                this.$emit('resize', componentName, size, this.$refs.lecturersListGrid.kendoWidget())
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            hide(componentName) {
                this.$emit('hide', componentName)
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            pinned(componentName) {
                this.$emit('pinned', componentName)
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            unpinned(componentName) {
                this.$emit('unpinned', componentName)
            },
            datasorceRequestEnd(e) {
                if (e.type == "read" && e.response) {
                    // 	console.log(e.response[0]);
                    //alert(e.respondashboard-ctrlse[0].TaskID);
                }
            },
            deactivatedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.deactivated ? 'badge-danger' : 'badge-success') + '">' + kendo.htmlEncode(dataItem.deactivated ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            isTemplateCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.isTemplate ? 'badge-success' : 'badge-secondary') + '">' + kendo.htmlEncode(dataItem.isTemplate ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            statusCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.status.indexOf('Active') >= 0 ? 'badge-success' : (dataItem.status.indexOf('Passed') >= 0 ? 'badge-warning' : 'badge-info')) + '">' + kendo.htmlEncode(dataItem.status) + '</span>';

                return templateHtml;
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.lecturersListGrid,
                        btns: this.gridBtns
                    }
                };
            },
            softDeleteBtnClick(args) {
                if (!this.hasParticipantDeleteRights) {
                    return this.$router.push(`/unauthorized`);
                }

                kendo.confirm(`${this.$t('registers.events.lecturers.confirmations.delete')} ${args.fullName}?`)
                    .then(function () {
                        this.softDeleteLecturer(args.id);
                    }.bind(this));
            },
            realDeleteBtnClick(args) {
                if (!this.hasParticipantDeleteRights) {
                    return this.$router.push(`/unauthorized`);
                }

                kendo.confirm(`${this.$t('registers.events.participants.confirmations.delete')} ${args.fullName}?`)
                    .then(function () {
                        this.realDeleteParticipant(args.id);
                    }.bind(this));
            },
            deleteWithPersonBtnClick(args) {
                if (!this.hasParticipantWithPersonDeleteRights) {
                    return this.$router.push(`/unauthorized`);
                }

                kendo.confirm(`${this.$t('registers.events.participants.confirmations.delete')} ${args.fullName}?`)
                    .then(function () {
                        this.deleteParticipantWithPerson(args.id);
                    }.bind(this));
            },
            softDeleteLecturer(id) {
                this.$http.delete('/api/participant/softDeleteParticipant',
                    { params: { id: id } }
                ).then((response) => {
                    this.refresh();
                    this.$emit("onEdit")

                    let statusCode = Number(this.$helpers.responseStatusCode(response));
                    this.$vs.notify({
                        title: this.$t('buttons.delete.action'),
                        text: this.$helpers.responseMessage(response),
                        color: statusCode === 240 ? 'warning' : 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })

                this.working = false;
            },
            realDeleteParticipant(id) {
                this.$http.delete('/api/participant/realDelete',
                    { params: { id: id } }
                ).then((response) => {
                    this.refresh();
                    this.$emit("onEdit")

                    let statusCode = Number(this.$helpers.responseStatusCode(response));
                    this.$vs.notify({
                        title: this.$t('buttons.delete.action'),
                        text: this.$helpers.responseMessage(response),
                        color: statusCode === 240 ? 'warning' : 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {

                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })

                this.working = false;
            },
            deleteParticipantWithPerson(id) {
                this.$http.delete('/api/participant/realDeleteWithPerson',
                    { params: { id: id } }
                ).then((response) => {
                    this.refresh();
                    this.$emit("onEdit")

                    let statusCode = Number(this.$helpers.responseStatusCode(response));
                    this.$vs.notify({
                        title: this.$t('buttons.delete.action'),
                        text: this.$helpers.responseMessage(response),
                        color: statusCode === 240 ? 'warning' : 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {


                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })

                this.working = false;
            },
            refresh() {
                const grid = this.$refs.lecturersListGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            },
            createBtnClick() {

            },
            syncLecturerWithMoodle(args) {
                if (!this.hasParticipantEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$vs.loading({
                    progress: 0,
                    text: `${this.$t('buttons.syncWithMoodle.btnText')}...`
                })

                this.$http.get('/api/moodle/syncParticipantWithMoodle', {
                    params: {
                        id: args.id
                    }
                })
                    .then((response) => {
                        this.$emit("syncLecturerWithMoodle", args.id);

                        this.$vs.notify({
                            title: this.$t('buttons.syncWithMoodle.btnText'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('buttons.syncWithMoodle.btnText'),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => {
                        this.$vs.loading.close();
                        this.refresh()
                    });
            },
            syncedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.syncWithMoodle ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.syncWithMoodle ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            notifiedCellTemplate: function(dataItem) {
                let templateHtml =
                    '<span class="badge ' +
                    (dataItem.notified ? "badge-success" : "badge-danger") +
                    '">' +
                    kendo.htmlEncode(
                        dataItem.notified ? this.$t("yes") : this.$t("no")
                    ) +
                    "</span>";

                return templateHtml;
            },
            hasCertificateCellTemplate: function (dataItem) {
            let templateHtml =
                    '<span class="badge ' +
                    (dataItem.hasCertificate
                        ? "badge-success"
                        : "badge-secondary") +
                    '">' +
                    kendo.htmlEncode(
                        dataItem.hasCertificate ? this.$t("yes") : this.$t("no")
                    ) +
                    "</span>";

                return templateHtml;
            },
            editBtnClick(args) {
                if (!this.hasParticipantEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$router.push('/participant/edit?id=' + args.id);

                //let routeData = this.$router.resolve({ name: 'eventParticipantEdit', query: { id: args.id } });
                //window.open(`${this.$store.getters.baseUrl}${routeData.href}`, '_blank');
            },
            detailsBtnClick(args) {
                if (!this.hasParticipantEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                let routeData = this.$router.resolve({
                    name: 'account',
                    params: { id: args.personId },
                    query: { eventId: args.registerEntityId }
                });
                window.open(routeData.href, '_blank');
            },
            onPersonEditClose() {
                this.showPersonEdit = false;
                this.personModel = null;
            },
            onPersonDetailsClose() {
                this.showPersonDetails = false;
                this.personModel = null;
            },
            onParticipantsEditClose() {
                this.showParticipantsEdit = false;
                this.participantsUpdateModel = null;
            },
            onPersonEdit(item) {
                this.$emit('onEdit');
                this.refresh();
            },
            personEditBtnClick(args) {
                if (!this.hasPersonEditRights) {
                    return this.$router.push(`/unauthorized`);
                }
                this.showPersonEditModal(Number(args.personId));
            },
            personDetailsBtnClick(args) {
                if (!this.hasPersonReadRights) {
                    return this.$router.push(`/unauthorized`);
                }
                this.showPersonDetailsModal(Number(args.personId));
            },
            showPersonEditModal(id) {
                personService
                    .getById(id)
                    .then(response => {
                        let model = response.data;
                        if (model) {
                            this.personModel = model;
                            this.showPersonEdit = true;
                        } else {
                            this.editModel = null;
                            this.showPersonEdit = false;
                        }
                    })
                    .catch(error => {
                        this.personModel = null;
                        this.showPersonEdit = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            showPersonDetailsModal(id) {
                personService
                    .getById(id)
                    .then(response => {
                        let model = response.data;
                        if (model) {
                            this.personModel = model;
                            this.showPersonDetails = true;
                        } else {
                            this.editModel = null;
                            this.showPersonDetails = true;
                        }
                    })
                    .catch(error => {
                        this.personModel = null;
                        this.showPersonDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onParticipantEditClose() {
                this.showParticipanrEdit = false;
                this.participantModel = null;
            },
            onParticipantEdit(item) {
                this.$emit('onEdit');
                this.refresh();
            },
            participantEditNewBtnClick(args) {
                if (!this.hasParticipantEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.showParticipantEditModal(args.id);
            },
            showParticipantEditModal(id) {
                participantService
                    .getById(id)
                    .then(response => {
                        let model = response.data.participant;
                        if (model) {
                            this.participantModel = model;
                            this.showParticipanrEdit = true;
                        } else {
                            this.participantModel = null;
                            this.showParticipanrEdit = false;
                        }
                    })
                    .catch(error => {
                        this.participantModel = null;
                        this.showParticipanrEdit = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            setListeners() {
                const self = this;

                $('#editSelectedLecturersBtn').on('click', (e) => {
                    e.preventDefault();

                    if (self.hasParticipantEditRights || self.hasPersonEditRights) {
                        const grid = self.$refs.lecturersListGrid.kendoWidget();
                        if (grid) {
                            self.updateSelected(grid);
                        }
                    }
                });

                $('#notifySelectedLecturersBtn').on('click', (e) => {
                    e.preventDefault();

                    console.log('hasParticipantEditRights:' + self.hasParticipantEditRights);

                    if (self.hasParticipantEditRights) {
                        const upcommigEvent = self.eventDetails && self.eventDetails.eventStartDate
                            && new Date() < new Date(self.eventDetails.eventStartDate);

                        console.log('upcommigEvent:' + upcommigEvent)
                        if (!upcommigEvent) {
                            kendo.confirm(`${self.$t('registers.events.participants.confirmations.notifedSelected')}`)
                            .done(() => {
                                const grid = self.$refs.lecturersListGrid.kendoWidget();
                                if (grid) {
                                    self.notifySelected(grid);
                                }
                            });
                        } else {
                            const grid = self.$refs.lecturersListGrid.kendoWidget();
                            if (grid) {
                                self.notifySelected(grid);
                            }
                        }
                    }
                });
            },
            newCertificateBtnClick(args) {
                if (args.hasCertificate) {
                    // Certificate has been issued
                    kendo
                        .confirm(
                            `${this.$t(
                                "registers.events.participants.confirmations.certificateIssed"
                            )}`
                        )
                        .then(
                            function () {
                                this.createCertificate(args.id);
                            }.bind(this)
                        );
                } else {
                    this.createCertificate(args.id);
                }
            },
            newCertificatesBtnClick() {
                if (!this.relatedEventId) {
                    this.$vs.notify({
                        title: this.$t('buttons.newCertificates.tooltipText'),
                        text: this.$t('notifications.thereIsNoConnectedEvent'),
                        color: "warning",
                        time: this.$store.getters.notificationDuration,
                    });

                    return;
                }
                this.createCertificates(this.relatedEventId);
            },
            createCertificate(id) {
                this.$vs.loading({
                    progress: 0,
                    text: `${this.$t('buttons.newCertificate.btnText')}...`
                })

                this.$http
                    .get("/api/lectors/createCertificate/" + id, {
                        responseType: "blob",
                    })
                    .then((response) => {
                        const blob = new Blob([response.data], {
                            type: "application/pdf",
                        });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute(
                            "download",
                            `Certificate_EventId_${this.Certificate_EventId_}_Id_${id}.pdf`
                        ); // or any other extension
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch((error) => {
                        this.$vs.notify({
                            title: this.$t('buttons.newCertificate.btnText'),
                            text: this.$helpers.errorText(error),
                            color: "danger",
                            time: this.$store.getters.notificationDuration,
                        });
                    }).then(() => {
                    this.$vs.loading.close();
                });
            },
            createCertificates(id) {
                this.$vs.loading({
                    progress: 0,
                    text: `${this.$t('buttons.newCertificate.btnText')}...`
                })

                this.$http
                    .get("/api/lectors/lectorsWithAllowedCertificateIds/" + id)
                    .then((response) => {
                        let participationIds = response.data;

                        if (participationIds.length > 0) {
                            try {
                                this.$http.post('api/lectors/createCertificates', participationIds, {
                                    responseType: "blob",
                                }).then(response => {
                                    if (response) {
                                        this.refresh();
                                        const blob = new Blob([response.data], {
                                            type: "application/pdf",
                                        })
                                        const url = window.URL.createObjectURL(blob);
                                        const link = document.createElement("a");
                                        link.href = url;
                                        link.setAttribute(
                                            "download",
                                            `Certificates.pdf`
                                        ); // or any other extension
                                        document.body.appendChild(link);
                                        link.click();
                                    }
                                }).catch(error => {
                                    this.$vs.notify({
                                        title: this.$t('notifications.error'),
                                        text: this.$helpers.errorText(error),
                                        color: "danger",
                                        time: this.$store.getters.notificationDuration,
                                    })
                                }).then(() => {
                                    this.$vs.loading.close();
                                });
                            } catch (error) {
                                this.$vs.notify({
                                    title: this.$t('notifications.error'),
                                    text: this.$helpers.errorText(error),
                                    color: "danger",
                                    time: this.$store.getters.notificationDuration,
                                });
                            }
                        } else {
                            let errorText = { message: this.$t('notifications.participationsWithAllowedCertificateNotAvailable') };
                            this.$vs.notify({
                                title: this.$t('notifications.error'),
                                text: this.$helpers.errorText(errorText),
                                color: "warning",
                                time: this.$store.getters.notificationDuration,
                            });
                        }
                    })
                    .catch((error) => {
                        this.$vs.notify({
                            title: this.$t(
                                "request.response.status." +
                                this.$helpers.errorStatusCode(error)
                            ),
                            text: this.$helpers.errorText(error),
                            color: "danger",
                            time: this.$store.getters.notificationDuration,
                        });
                    });
            },
        },
        async created() {
            window.JSZip = JSZip;
            this.eventDetails = (await eventService.getDetails(this.relatedEventId)).data;
        },
        mounted() {
            this.setListeners();
        },
        beforeDestroy() {
            $('#editSelectedLecturersBtn').off('click');
            $('#notifySelectedLecturersBtn').off('click');
        },
        computed: {
            ...mapGetters(['claims', 'allowLecturersSoftDelete']),
            token: function () {
                return this.$store.getters.authToken;
            },
            userSettings() {
                let grid = this.$refs.lecturersListGrid.kendoWidget();
                return grid.getOptions();
            },
            filter() {
                if (this.relatedEventId > 0) {
                    return {
                        logic: "and", filters: [
                            {
                                field: 'RegisterEntityId',
                                operator: 'eq',
                                value: this.relatedEventId
                            }]
                    }
                }
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            },
            hasPersonEditRights() {
                return this.$store.getters.claims.person.update
                    || this.$store.getters.claims.event.update;
            },
            hasPersonReadRights() {
                return this.$store.getters.claims.person.read
                    || this.$store.getters.claims.event.read;
            },
            hasParticipantEditRights() {
                return this.$store.getters.claims.participant.read
                    || this.$store.getters.claims.event.read;
            },
            hasParticipantDeleteRights() {
                return this.$store.getters.claims.participant.delete
                    || this.$store.getters.claims.event.delete;
            },
            hasParticipantWithPersonDeleteRights() {
                return this.$store.getters.claims.participantWithPerson.delete;
            },
            gridBtns() {
                let arr = [];


                if (this.hasParticipantEditRights) {
                    //arr.push({
                    //    name: "edit",
                    //    text: "",
                    //    tooltip: this.$t('buttons.edit.btnText'),
                    //    class: 'btn btn-primary',
                    //    icon: "fas fa-edit",
                    //    show: true,
                    //    clickHandler: this.editBtnClick
                    //});

                    arr.push({
                        name: "participantEditNew",
                        text: "",
                        tooltip: this.$t('buttons.edit.btnText'),
                        class: 'btn btn-primary',
                        icon: "fas fa-edit",
                        show: true,
                        clickHandler: this.participantEditNewBtnClick
                    });

                    arr.push({
                        name: "details",
                        text: "",
                        tooltip: this.$t('buttons.details.btnText'),
                        class: 'btn btn-info',
                        icon: "fas fa-eye",
                        show: true,
                        clickHandler: this.detailsBtnClick
                    });

                    arr.push({
                        name: "syncLecturerWithMoodle",
                        text: this.$t('buttons.syncWithMoodle.btnText'),
                        tooltip: this.$t("buttons.syncWithMoodle.btnText"),
                        class: 'btn btn-info',
                        icon: "fas fa-sync",
                        show: true,
                        clickHandler: this.syncLecturerWithMoodle
                    });
                }

                if (this.hasParticipantDeleteRights) {
                    if (this.allowLecturersSoftDelete) {
                        arr.push({
                            name: "delete",
                            text: "",
                            tooltip: this.$t('buttons.delete.btnText'),
                            class: 'btn btn-danger',
                            icon: "fas fa-times",
                            show: true,
                            clickHandler: this.softDeleteBtnClick
                        });
                    }

                    arr.push({
                        name: "realDeleteParticipant",
                        text: "",
                        tooltip: this.allowLecturersSoftDelet ? this.$t('buttons.realDelete.btnText') : this.$t("buttons.delete.btnText"),
                        class: 'btn btn-danger',
                        icon: "fas fa-times",
                        show: true,
                        clickHandler: this.realDeleteBtnClick
                    });
                }

                if(this.hasParticipantWithPersonDeleteRights) {
                    arr.push({
                        name: "deleteParticipantWithPerson",
                        text: "",
                        tooltip: this.$t('buttons.deleteWithPerson.btnText'),
                        class: 'btn btn-danger',
                        icon: "fas fa-times",
                        show: true,
                        clickHandler: this.deleteWithPersonBtnClick
                    });
                }

                if (this.hasPersonEditRights) {
                    arr.push({
                        name: "personEdit",
                        text: "",
                        tooltip: this.$t('buttons.personEdit.btnText'),
                        class: 'btn btn-primary',
                        icon: "fas fa-user-cog",
                        show: true,
                        clickHandler: this.personEditBtnClick
                    });

                    arr.push({
                        name: "personDetails",
                        text: "",
                        tooltip: this.$t('buttons.personDetails.btnText'),
                        class: 'btn btn-primary',
                        icon: "fas fa-info-circle",
                        show: true,
                        clickHandler: this.personDetailsBtnClick
                    });

                    arr.push({
                        name: "newCertificate",
                        text: "",
                        tooltip: this.$t("buttons.newCertificate.btnText"),
                        class: "btn btn-primary",
                        icon: "fas fa-certificate",
                        show: true,
                        clickHandler: this.newCertificateBtnClick,
                    });

                }

                return arr;
            },
        }
    }
</script>


<style>
/*
    Use the DejaVu Sans font for display and embedding in the PDF file.
    The standard PDF fonts have no support for Unicode characters.
*/
.k-pdf-export .k-grid {
    font-family: "DejaVu Sans", "Arial", sans-serif;
}

.k-pdf-export .k-filterable .k-grid-filter {
    display: none;
}

.k-pdf-export .k-with-icon .k-header-column-menu {
    display: none;
}

.k-grid .k-grid-header .k-header .k-link {
    height: auto;
}

.k-grid .k-grid-header .k-header {
    white-space: normal;
}

.k-grid-edit, .k-grid-details, .k-grid-delete, .k-grid-pdf, .k-grid-excel {
    padding: 0;
    margin-bottom: 2px;
}

#editSelectedLecturersBtn {
    padding: 0;
    margin-right: 10px;
}

#notifySelectedLecturersBtn {
    padding: 0;
    margin-right: 10px;
}
</style>
